//instagram 图标
const InstagramIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_48984_51523)">
        <path
          d="M16 8C16 3.58174 12.4183 1.04904e-05 7.99999 1.04904e-05C3.58173 1.04904e-05 0 3.58174 0 8C0 11.7518 2.58288 14.8999 6.06739 15.7644V10.4447H4.41772V8H6.06739V6.9466C6.06739 4.22365 7.29964 2.96158 9.97292 2.96158C10.4797 2.96158 11.3543 3.06094 11.712 3.16033V5.37645C11.5232 5.35658 11.1953 5.34663 10.7878 5.34663C9.47603 5.34663 8.96918 5.84353 8.96918 7.13543V8H11.5823L11.1334 10.4447H8.96918V15.9414C12.9303 15.463 16 12.0902 16 8Z"
          fill="#0866FF"
        />
        <path
          d="M11.1336 10.4447L11.5825 8.00001H8.96945V7.1354C8.96945 5.8435 9.47627 5.34663 10.788 5.34663C11.1955 5.34663 11.5234 5.35655 11.7123 5.37642V3.16033C11.3545 3.06094 10.48 2.96154 9.97317 2.96154C7.29992 2.96154 6.06763 4.22366 6.06763 6.9466V8.00001H4.41797V10.4447H6.06763V15.7644C6.68661 15.918 7.33381 16 8.00024 16C8.32837 16 8.65169 15.9798 8.96945 15.9414V10.4447H11.1336Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_48984_51523">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InstagramIcon
